import Dynamic from '@base/Dynamic/Dynamic';
import CombatBanner from '@cont/Banner/CombatBanner';
import Content from './Content';

const Modals = Dynamic(() => import('./Modals'));

const Landing = () => (
  <>
    <CombatBanner />
    <Content />
    <Modals />
  </>
);

export default Landing;
